import { CandidateDocuments, OperationResultOfCandidateDocuments, ImmigrationDocument, EmployeeDoc, EmployeeProfile, ExitDocument, OperationResultOfExitDocument, EmployeeDocCombined, CWProfile, OperationResultOfCWDocument } from './api.gen';
import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_BASE_URL } from './api.gen';
import { HttpClient } from '@angular/common/http';
import { CommonService } from './common.service';
import { Logger } from '../utils/Logger';
import { nullSafe } from '../utils';


@Injectable()
export class DocumentUploadService {
    baseUrl: string;
    constructor(private http: HttpClient, private common: CommonService, @Inject(API_BASE_URL) baseUrl?: string) {
        this.baseUrl = baseUrl;
    }


    postImmigrationFile(fileDetails: ImmigrationDocument, TMT_Check_Status:string, file?: File): Observable<OperationResultOfCandidateDocuments> {
        const url = this.baseUrl + '/api/Immigration/DocumentsUpload';
        const formData: FormData = new FormData();
        formData.append('id', fileDetails.id.toString());
        formData.append('fileName', fileDetails.fileName);
        formData.append('documentName', fileDetails.documentName);
        formData.append('employeeId', fileDetails.createdById.toString());
        formData.append('documentTypeId', fileDetails.documentTypeId.toString());
        formData.append('immigrationProfileId', fileDetails.immigrationProfileId.toString());
        formData.append('description', fileDetails.description.toString());
        formData.append('documentNameId', fileDetails.documentNameId.toString());
        formData.append('moduleType', fileDetails.moduleType.toString());
        formData.append('checks', fileDetails.checks==null ? " ":fileDetails.checks.toString());
        formData.append('TMT_Check_Status', TMT_Check_Status == null ? " " : TMT_Check_Status.toString());
        formData.append('additionalReqId', fileDetails.additionalReqId == null ? null : fileDetails.additionalReqId.toString());
        formData.append('dependentId', fileDetails.dependentId == null ? "" : fileDetails.dependentId.toString());
        formData.append('synced', fileDetails.synced == null ? "" : fileDetails.synced.toString());
          
      if (fileDetails.id > 0) {
            formData.append('fileGuId', fileDetails.fileGuiId.toString());
            formData.append('modifiedById', fileDetails.modifiedById.toString());
        }
        if (file != null) {
            formData.append('file', file, fileDetails.fileName);
      }
        return this.http.post<OperationResultOfCandidateDocuments>(url, formData);
    }

    postExitFile(fileDetails: ExitDocument, file?: File): Observable<OperationResultOfExitDocument> {
        const url = this.baseUrl + '/api/Exit/DocumentsUpload';
        const formData: FormData = new FormData();
        formData.append('id', fileDetails.id.toString());
        formData.append('fileName', fileDetails.fileName);
        formData.append('documentName', fileDetails.documentName);
        formData.append('employeeId', fileDetails.createdById.toString());
        formData.append('documentTypeId', fileDetails.documentTypeId.toString());
        formData.append('exitRequestId', fileDetails.exitRequestId.toString());
        formData.append('description', fileDetails.description.toString());
        formData.append('documentNameId', fileDetails.documentNameId.toString());
        formData.append('type', fileDetails.type.toString());

        if (fileDetails.id > 0) {
            formData.append('fileGuId', fileDetails.fileGuiId.toString());
            formData.append('modifiedById', fileDetails.modifiedById.toString());
        }
        if (file != null) {
            formData.append('file', file, fileDetails.fileName);
        }
        return this.http.post<OperationResultOfExitDocument>(url, formData);
    }

    postFile(fileDetails: CandidateDocuments, TMT_Check_Status :string, file?: File): Observable<OperationResultOfCandidateDocuments> {
        const url = this.baseUrl + '/api/Candidate/DocumentsUpload';
        const formData: FormData = new FormData();
        formData.append('id', fileDetails.id?.toString());
        formData.append('fileName', fileDetails.fileName);
        formData.append('documentName', fileDetails.documentName);
        formData.append('employeeId', fileDetails.createdById?.toString());
        formData.append('documentTypeId', fileDetails.documentTypeId?.toString());
        formData.append('cadndidateProfileId', fileDetails.candidateProfileId?.toString());
        formData.append('docNameId', fileDetails.documentId?.toString());
        formData.append('moduleType', fileDetails.moduleType?.toString());
        formData.append('checks', fileDetails.checks==null ? " ":fileDetails.checks?.toString());
        formData.append('TMT_Check_Status', TMT_Check_Status==null ? " ":TMT_Check_Status?.toString());
        
        if (fileDetails.id > 0) {
            formData.append('fileGuId', fileDetails.fileGuiId.toString());
            formData.append('modifiedById', fileDetails.modifiedById.toString());
        }
        if (file != null) {
            formData.append('file', file, fileDetails.fileName);
        }
        return this.http.post<OperationResultOfCandidateDocuments>(url, formData);
    }

    downloadDocumentFile(fileName: string): void {
        const fileUrl = this.baseUrl + `/api/Candidate/DownLoadDocumentFile?fileName=${fileName}`;
        const fileNameExact = fileName.slice(fileName.lastIndexOf("\\") + 1);
        this.http.post<Blob>(fileUrl, fileName, { responseType: 'Blob' as 'json' })
            .subscribe(resp => {
                // details.documentName.replace(/ +/g, "_")
                //     + this.common.getFileExtension(details.fileName);
                if ((window.navigator as any).msSaveOrOpenBlob) {
                    (window.navigator as any)
                        .msSaveBlob(resp, fileNameExact);
                } else {
                    const url = window.URL.createObjectURL(resp);
                    const a = document.createElement("a");
                    document.body.appendChild(a);
                    a.setAttribute("style", "display: none");
                    a.href = url;
                    a.download = fileNameExact;
                    a.click();
                    window.URL.revokeObjectURL(url);
                    a.remove();
                }
            },
                error => {
                    Logger.error(error);
                });
    }

    downloadAttachmentFile(fileName: string) {        
      const fileNameExact = nullSafe(() => encodeURIComponent(fileName.trim()));
      const fileUrl = this.baseUrl + "/api/Candidate/DownloadAttachmentFile?fileName="+fileNameExact;
        return this.http.post<Blob>(fileUrl, fileName, { responseType: 'Blob' as 'json' });
    }

    downloadImmigrationFile(details: ImmigrationDocument, filename: string): Observable<any> {
        const fileUrl = this.baseUrl + "/api/Immigration/DocumentDownload";
        return this.http.post<Blob>(fileUrl, details, { responseType: 'Blob' as 'json' });
    }

    downloadExitFile(details: ExitDocument, filename: string): Observable<any> {
        const fileUrl = this.baseUrl + "/api/Exit/DocumentDownload";
        return this.http.post<Blob>(fileUrl, details, { responseType: 'Blob' as 'json' });
    }
    downloadExitBulkuploadTemplate(filename: string): Observable<any> {
        const fileUrl = this.baseUrl + "/api/Exit/TemplateDownload";
        return this.http.post<Blob>(fileUrl, filename, { responseType: 'Blob' as 'json' });
    }
    ExitBulkupload(fileName: String, file?: File): Observable<OperationResultOfExitDocument> {
        const url = this.baseUrl + '/api/Exit/TemplateUpload';
        const formData: FormData = new FormData();
       
        formData.append('fileName', fileName.toString());
      
        if (file != null) {
            formData.append('file', file, fileName.toString());
        }
        return this.http.post<OperationResultOfExitDocument>(url, formData);
    }
  ValidateIEBulkuploadTemplate(fileName: String, file?: File): Observable<OperationResultOfExitDocument> {
    const url = this.baseUrl + '/api/Exit/ValidateIETemplate';
    const formData: FormData = new FormData();

    formData.append('fileName', fileName.toString());

    if (file != null) {
      formData.append('file', file, fileName.toString());
    }
    return this.http.post<OperationResultOfExitDocument>(url, formData);
  }
    downloadFile(details: CandidateDocuments, filename: string): Observable<any> {
        const fileUrl = this.baseUrl + "/api/Candidate/DocumentDownload";
        return this.http.post<Blob>(fileUrl, details, { responseType: 'Blob' as 'json' });
    }

    downloadAll(id: number, module: String): Observable<Blob> {
        let url = this.baseUrl + `/api/Candidate/DownloadAll?id=${id}`;
        if (module && module.length > 0) {
            url = url + `&module=${module}`;
        }
        return this.http.post<Blob>(url, id, { responseType: 'Blob' as 'json' });
    }

    downloadAllImmigration(id: number, typeId: number): Observable<Blob> {
        let url = this.baseUrl + `/api/Immigration/DownloadAll?id=${id}`;
        if (typeId > 0) {
            url = url + `&typeId=${typeId}`;
        }
        return this.http.post<Blob>(url, id, { responseType: 'Blob' as 'json' });
    }
    downloadAllEmailTemplate(): Observable<Blob> {
        let url = this.baseUrl + `/api/Systems/DownloadEmailTemplates`;
        
        return this.http.post<Blob>(url,null,  { responseType: 'Blob' as 'json' });
    }
    downloadAllExit(id: number, typeId: number): Observable<Blob> {
        let url = this.baseUrl + `/api/Exit/DownloadAll?id=${id}`;
        if (typeId > 0) {
            url = url + `&typeId=${typeId}`;
        }
        return this.http.post<Blob>(url, id, { responseType: 'Blob' as 'json' });
    }

    downloadAllEmployeeDocs(id: number, isEdit: boolean): Observable<Blob> {
        const url = this.baseUrl + `/api/Employeeprofile/DownloadAll?id=${id}&isEdit=${isEdit}`;
        return this.http.post<Blob>(url, id, { responseType: 'Blob' as 'json' });
    }

    downloadAllCWDocs(id: number): Observable<Blob> {
        const url = this.baseUrl + `/api/CW/DownloadAll?id=${id}`;
        return this.http.post<Blob>(url, id, { responseType: 'Blob' as 'json' });
    }
  postEmployeeFile(fileDetails: EmployeeDoc, empProfile: EmployeeProfile, isAdditionalUpload: boolean, file?: File): Observable<OperationResultOfCandidateDocuments> {
    const url = this.baseUrl + '/api/EmployeeProfile/DocumentsUpload/' + isAdditionalUpload;
        const formData: FormData = new FormData();
        formData.append('id', fileDetails.id.toString());
        formData.append('fileName', fileDetails.fileName);
        formData.append('documentName', fileDetails.documentName);
        formData.append('employeeId', fileDetails.createdById.toString());
        formData.append('documentTypeId', fileDetails.documentTypeId.toString());
        formData.append('employeeProfileEditRequestId', fileDetails.employeeProfileEditRequestId.toString());
        formData.append('profileEmployeeId', fileDetails.employeeId.toString());
        formData.append('employeeProfile', JSON.stringify(empProfile));
        formData.append('description', fileDetails['description'].toString());
        formData.append('documentNameId', fileDetails['documentNameId'].toString());
        formData.append('additionalReqId', fileDetails.additionalReqId == null ? "" : fileDetails.additionalReqId.toString());
        formData.append('dependentId', fileDetails.dependentId == null ? "" : fileDetails.dependentId.toString());
        
        if (fileDetails.id > 0) {
            formData.append('fileGuId', fileDetails.fileGuiId.toString());
            formData.append('modifiedById', fileDetails.modifiedById.toString());
        }
        if (file != null) {
            formData.append('file', file, fileDetails.fileName);
        }
        return this.http.post<OperationResultOfCandidateDocuments>(url, formData);
    }
    postCWFile(fileDetails: EmployeeDoc, cwProfile: CWProfile,  file?: File): Observable<OperationResultOfCWDocument> {
        const url = this.baseUrl + '/api/CW/DocumentsUpload' ;
            const formData: FormData = new FormData();
            formData.append('id', fileDetails.id.toString());
            formData.append('fileName', fileDetails.fileName);
            formData.append('documentName', fileDetails.documentName);
            formData.append('employeeId', fileDetails.createdById.toString());
            formData.append('documentTypeId', fileDetails.documentTypeId.toString());
            formData.append('cwProfile', JSON.stringify(cwProfile));
            formData.append('description', fileDetails['description'].toString());
            formData.append('documentNameId', fileDetails['documentNameId'].toString());
           
            if (fileDetails.id > 0) {
                formData.append('fileGuId', fileDetails.fileGuiId.toString());
                formData.append('modifiedById', fileDetails.modifiedById.toString());
            }
            if (file != null) {
                formData.append('file', file, fileDetails.fileName);
            }
            return this.http.post<OperationResultOfCWDocument>(url, formData);
        }

    /**
     * Uploads (or replaces) a governance document file.
     * Persists into gov.GovernanceDocumentUploads via the GovernanceRequest controller.
     */
    postGovernanceFile(fileDetails: {
        id: number; fileName: string; documentName: string;
        createdById: number; modifiedById: number; documentTypeId: number;
        documentNameId: number; description: string; governanceProfileId: number;
        fileGuiId: string;
    }, file?: File): Observable<any> {
        const url = this.baseUrl + '/api/GovernanceRequest/DocumentsUpload';
        const formData: FormData = new FormData();
        formData.append('id', fileDetails.id.toString());
        formData.append('fileName', fileDetails.fileName);
        formData.append('documentName', fileDetails.documentName);
        formData.append('employeeId', fileDetails.createdById.toString());
        formData.append('documentTypeId', fileDetails.documentTypeId.toString());
        formData.append('documentNameId', fileDetails.documentNameId.toString());
        formData.append('governanceProfileId', fileDetails.governanceProfileId.toString());
        formData.append('description', fileDetails.description?.toString() ?? '');
        if (fileDetails.id > 0) {
            formData.append('fileGuId', fileDetails.fileGuiId.toString());
            formData.append('modifiedById', fileDetails.modifiedById.toString());
        }
        if (file != null) {
            formData.append('file', file, fileDetails.fileName);
        }
        return this.http.post<any>(url, formData);
    }

    downloadGovernanceFile(fileDetails: { fileGuiId: string; fileName: string; documentName?: string }): Observable<Blob> {
        const url = this.baseUrl + '/api/GovernanceRequest/DocumentDownload';
        return this.http.post<Blob>(url, fileDetails, { responseType: 'Blob' as 'json' });
    }

    deleteGovernanceFile(fileDetails: { id: number; fileGuiId: string }): Observable<boolean> {
        const url = this.baseUrl + '/api/GovernanceRequest/DocumentDelete';
        return this.http.post<boolean>(url, fileDetails);
    }

    getLatestDownloadableGovernanceDocument(governanceRequestId: number, documentTypeId?: number): Observable<any> {
        const url = this.baseUrl + `/api/GovernanceRequest/GetLatestDownloadableDocument?governanceRequestId=${governanceRequestId}&documentTypeId=${documentTypeId}`;
        return this.http.post<any>(url, null);
    }

    downloadAllGovernanceDocs(profileId: number): Observable<Blob> {
        const url = this.baseUrl + `/api/GovernanceRequest/DownloadAll?id=${profileId}`;
        return this.http.post<Blob>(url, profileId, { responseType: 'Blob' as 'json' });
    }

    getGovernanceActivityEmailMessage(governanceRequestId: number, governanceRequestActivityId: number, activityTemplateId: number = 0): Observable<any> {
        const url = this.baseUrl + `/api/Email/GetGovernanceActivityEmailMessage?governanceRequestId=${governanceRequestId}&governanceRequestActivityId=${governanceRequestActivityId}&activityTemplateId=${activityTemplateId}`;
        return this.http.get<any>(url);
    }

    sendGovernanceMail(governanceRequestId: number, message: any): Observable<any> {
        const url = this.baseUrl + `/api/Email/SendGovernanceMail?governanceRequestId=${governanceRequestId}`;
        return this.http.post<any>(url, message);
    }

    governanceSaveAsDraft(message: any): Observable<any> {
        const url = this.baseUrl + '/api/Email/GovernanceSaveAsDraft';
        return this.http.post<any>(url, message);
    }

    getGovernanceEmailAttachments(governanceRequestId: number, activityId: number, activityTemplateId: number): Observable<any[]> {
        const url = this.baseUrl + `/api/GovernanceRequest/GetGovernanceEmailAttachments?governanceRequestId=${governanceRequestId}&activityId=${activityId}&activityTemplateId=${activityTemplateId}`;
        return this.http.get<any[]>(url);
    }

    postGovernanceEmailAttachment(details: {
        id: number; fileName: string; fileGuiId: string;
        governanceRequestActivityId: number; emailTemplateId: number;
    }, file?: File): Observable<any> {
        const url = this.baseUrl + '/api/GovernanceRequest/GovernanceEmailAttachmentsUpload';
        const formData: FormData = new FormData();
        formData.append('Id', details.id.toString());
        formData.append('fileName', details.fileName);
        formData.append('governanceRequestActivityId', details.governanceRequestActivityId.toString());
        formData.append('emailTemplateId', details.emailTemplateId.toString());
        if (details.id > 0) {
            formData.append('fileGuId', details.fileGuiId);
        }
        if (file != null) {
            formData.append('file', file, details.fileName);
        }
        return this.http.post<any>(url, formData);
    }

    attachExistingGovernanceDocsToMail(attachments: any[]): Observable<any[]> {
        const url = this.baseUrl + '/api/GovernanceRequest/AttachExistingDocsToMail';
        return this.http.post<any[]>(url, attachments);
    }

    deleteGovernanceEmailAttachment(attachment: any): Observable<boolean> {
        const url = this.baseUrl + '/api/GovernanceRequest/DeleteGovernanceEmailAttachment';
        return this.http.post<boolean>(url, attachment);
    }
    postMainEmployeeFile(fileDetails: EmployeeDoc, file?: File): Observable<OperationResultOfCandidateDocuments> {
        const url = this.baseUrl + '/api/EmployeeProfile/DocumentsUploadToProfile';
        const formData: FormData = new FormData();
        formData.append('id', fileDetails.id.toString());
        formData.append('fileName', fileDetails.fileName);
        formData.append('documentName', fileDetails.documentName);
        formData.append('employeeId', fileDetails.createdById.toString());
        formData.append('documentTypeId', fileDetails.documentTypeId.toString());
        formData.append('employeeProfileId', fileDetails.employeeProfileId.toString());
        formData.append('profileEmployeeId', fileDetails.employeeId.toString());
        formData.append('description', fileDetails['description'].toString());
        formData.append('documentNameId', fileDetails['documentNameId'].toString());
        formData.append('dependentId', fileDetails.dependentId == null ? "" : fileDetails.dependentId.toString());

        if (fileDetails.id > 0) {
            formData.append('fileGuId', fileDetails.fileGuiId.toString());
            formData.append('modifiedById', fileDetails.modifiedById.toString());
        }
        if (file != null) {
            formData.append('file', file, fileDetails.fileName);
        }
        return this.http.post<OperationResultOfCandidateDocuments>(url, formData);
    }


    downloadEmployeeFile(details: EmployeeDocCombined, filename: string): Observable<any> {
        const fileUrl = this.baseUrl + "/api/EmployeeProfile/DocumentDownload";
        return this.http.post<Blob>(fileUrl, details, { responseType: 'Blob' as 'json' });
    }

}
